import 'nprogress/nprogress.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-perfect-scrollbar/dist/css/styles.css';
import App from './App';
import './index.css';
import ReactGA from 'react-ga4';

const root = createRoot(document.getElementById('root')!);

//Initialize GA4
ReactGA.initialize('G-L26BDXFLXF');

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
